import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';
import {
    FAILURE_DIRECT_CUSTOMERS,
    FAILURE_SUCCESS_LIST,
    FAILURE_SUCCESS_LIST_ENTRY_HISTORY,
    FAILURE_SUCCESS_LIST_OVERVIEW,
    FAILURE_SUCCESS_LIST_REGIONS,
    FAILURE_SUCCESS_LIST_TOPICS,
    REQUEST_DIRECT_CUSTOMERS,
    REQUEST_SUCCESS_LIST,
    REQUEST_SUCCESS_LIST_ENTRY_HISTORY,
    REQUEST_SUCCESS_LIST_OVERVIEW,
    REQUEST_SUCCESS_LIST_REGIONS,
    REQUEST_SUCCESS_LIST_TOPICS,
    SUCCESS_DIRECT_CUSTOMERS,
    SUCCESS_SUCCESS_LIST,
    SUCCESS_SUCCESS_LIST_ENTRY_HISTORY,
    SUCCESS_SUCCESS_LIST_OVERVIEW,
    SUCCESS_SUCCESS_LIST_REGIONS,
    SUCCESS_SUCCESS_LIST_TOPICS,
} from 'src/store/success-list/actions';

/*  Direct Customers  */
export function directCustomersReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_DIRECT_CUSTOMERS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DIRECT_CUSTOMERS: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_DIRECT_CUSTOMERS:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

/* Success List Overview */
export function successListOverviewReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_SUCCESS_LIST_OVERVIEW:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_SUCCESS_LIST_OVERVIEW: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_SUCCESS_LIST_OVERVIEW:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

/* Success List Topics */
export function successListTopicsReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_SUCCESS_LIST_TOPICS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_SUCCESS_LIST_TOPICS: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_SUCCESS_LIST_TOPICS:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

/* Success List */
export function successListReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_SUCCESS_LIST:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_SUCCESS_LIST: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_SUCCESS_LIST:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Success List Entry History */
export function successListEntryHistoryReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_SUCCESS_LIST_ENTRY_HISTORY:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_SUCCESS_LIST_ENTRY_HISTORY: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_SUCCESS_LIST_ENTRY_HISTORY:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

/* Success List Regions */
export function successListRegionsReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_SUCCESS_LIST_REGIONS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_SUCCESS_LIST_REGIONS: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_SUCCESS_LIST_REGIONS:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}
